import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { css } from "@emotion/core";

export const LayoutContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    width: 100%;
    display: grid;
    height: 100dvh;
    background-color: ${theme.colors.white};
    grid-template-areas:
      "topNav topNav"
      "display display";

    grid-template-rows: 64px auto;
    grid-template-columns: 1fr 1fr;

    ${theme.breakpoints.md} {
      grid-template-areas:
        "topNav topNav"
        "sideNav display";

      grid-template-rows: 72px auto;
      grid-template-columns: 233px auto;
    }
  `}
`;

export const SideNavContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    grid-area: sideNav;
    display: none;
    border-right: 1px solid ${theme.colors.gray300};

    ${theme.breakpoints.md} {
      display: block;
    }
  `}
`;

export const Display = styled.div<NectarTheme>`
  ${({ theme }) => css`
    grid-area: display;
    display: grid;
    grid-template-rows: 1fr 150px;
    grid-template-columns: 1fr;
    grid-template-areas:
      "."
      "footer";
    overflow-y: auto;
    padding: ${theme.spacings.lg};
    /* Hide scrollbar for Chrome, Safari and Opera */
    .example::-webkit-scrollbar {
      display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .example {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    ${theme.breakpoints.sm} {
      padding: ${theme.spacings.xxl} ${theme.spacings.lg} ${theme.spacings.sm};
    }
  `}
`;
